
export const MAX_FILE_SIZE_MB = 5;
export const MAX_NAME_LENGTH = 100;
const maxFileSize = MAX_FILE_SIZE_MB * 1024 * 1024; // 5 MB
const allowedExtensions = {
    'branch_picture' : ['jpg', 'jpeg', 'png', 'gif'],
    'profile_picture' : ['jpg', 'jpeg', 'png']
};
const namePattern = /^[^\\/<>:"|?*\x00-\x1F\x7F]+$/u;

export function createFileChecker() {
    const fileChecker = {};

    const fileCheckerFunctions = {
        'size-limit' : null,
        'wrong-format' : null,
        'long-name' : null,
        'improper-name' : null,
        'universal' : null
    };

    let filePurpose = null;

    fileChecker.onSizeLimit = (callback) => onStatus(fileCheckerFunctions, 'size-limit', callback);
    fileChecker.onWrongFormat = (callback) => onStatus(fileCheckerFunctions, 'wrong-format', callback);
    fileChecker.onLongName = (callback) => onStatus(fileCheckerFunctions, 'long-name', callback);
    fileChecker.onImproperName = (callback) => onStatus(fileCheckerFunctions, 'improper-name', callback);
    fileChecker.setUniversalStatus = (callback) => onStatus(fileCheckerFunctions, 'universal', callback);

    fileChecker.setFilePurpose = (filePurposeValue) => {
        filePurpose = filePurposeValue;
    };
    fileChecker.checkFile = (file) => checkFile(fileCheckerFunctions, filePurpose, file);

    return fileChecker;
}

function checkFile(fileCheckerFunctions, filePurpose, file) {

    if(!(file instanceof File)) {
        return false;
    }

    const fileName = file.name;
    const fileSize = file.size; // in bytes
    const extension = fileName.split('.').pop().toLowerCase();

    const universalFunction = fileCheckerFunctions['universal'];

    let valid = true;

    if(fileSize>maxFileSize) {
        valid = false;

        const sizeLimitFunc = fileCheckerFunctions['size-limit'];

        if(sizeLimitFunc) {
            sizeLimitFunc(MAX_FILE_SIZE_MB);
        } else if (universalFunction) {
            universalFunction(`Your file is too large. It has to be below ${MAX_FILE_SIZE_MB}MB`);
        }
    }

    if(!checkExtensions(filePurpose, extension)) {
        valid = false;
        
        const extensionFunc = fileCheckerFunctions['wrong-format'];

        if(extensionFunc) {
            extensionFunc(extension);
        } else if (universalFunction) {
            universalFunction(`Your file format ".${extension}" is not supported.`);
        }
    }

    if(fileName.length>MAX_NAME_LENGTH) {
        valid = false;
        
        const fileNameLengthFunc = fileCheckerFunctions['long-name'];

        if(fileNameLengthFunc) {
            fileNameLengthFunc(MAX_NAME_LENGTH);
        } else if (universalFunction) {
            universalFunction(`Your file name exceeds ${MAX_NAME_LENGTH} characters.`);
        }
    }

    const normalized = fileName.normalize('NFC');
    if(!namePattern.test(normalized)) {
        valid = false;
        
        const filenamePatternFunc = fileCheckerFunctions['improper-name'];

        if(filenamePatternFunc) {
            filenamePatternFunc();
        } else if (universalFunction) {
            universalFunction(`Your file name contains invalid characters.`);
        }
    }

    return valid;
}

function onStatus(fileCheckerFunctions, status, callback) {
    if(!(callback instanceof Function))
        throw new Error(`${callback} is not a function!`);

    fileCheckerFunctions[status] = callback;
}

function checkExtensions(filePurpose, extension) {
    const extensionsArray = allowedExtensions[filePurpose];
    if (!extensionsArray) throw new Error(`Unknown file purpose: ${filePurpose}`);
    return extensionsArray.includes(extension);
}
